import { api } from "./api";

export interface Destaque {
  id: string;
  nick: string;
  data_inicio: string;
  data_fim: string;
  status: string; // "A" = Ativo, "I" = Inativo
  categoria: string; // "P" = Praça, "O" = Oficial
  criado_em: string;
  alterado_em: string;
}

export interface CreateDestaqueData {
  nick: string;
  data_inicio: string;
  data_fim: string;
  categoria: string;
}

export interface UpdateDestaqueData {
  nick?: string;
  data_inicio?: string;
  data_fim?: string;
  status?: string;
  categoria?: string;
}

export const destaquesService = {
  listar: async (categoria?: string): Promise<Destaque[]> => {
    const params = categoria ? { categoria } : {};
    const response = await api.get("/destaques", { params });
    return response.data;
  },

  criar: async (data: CreateDestaqueData): Promise<Destaque> => {
    const response = await api.post("/destaques", data);
    return response.data;
  },

  atualizar: async (id: string, data: UpdateDestaqueData): Promise<Destaque> => {
    const response = await api.put(`/destaques/${id}`, data);
    return response.data;
  },

  excluir: async (id: string): Promise<void> => {
    await api.delete(`/destaques/${id}`);
  },
};
